var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about"},[_c('img',{attrs:{"width":"100%","src":"https://yibaoobj.oss-cn-shanghai.aliyuncs.com/prod/h5/yibao/%E5%85%B3%E4%BA%8E%E6%88%91%E4%BB%AC.jpg"}})])
}]

export { render, staticRenderFns }